import { NavLink } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import {
  Mail, FileText, Megaphone, BarChart3, LogOut, X, Users,
  ShieldCheck, Shield, Inbox, Settings, CalendarDays,
  LayoutDashboard, Book, ChevronsRight, Bot, BookOpen, Sparkles
} from 'lucide-react'
import './Sidebar.css'

const navGroups = [
  {
    title: 'Workspace',
    items: [
      { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
      { path: '/co-pilot', icon: Bot, label: 'Insights' },
      { path: '/campaigns', icon: Megaphone, label: 'Campaigns' },
      { path: '/inbox', icon: Inbox, label: 'ReplyHub' },
      { path: '/contacts', icon: Users, label: 'Contacts' },
    ],
  },
  {
    title: 'Infrastructure',
    items: [
      { path: '/email-accounts', icon: Mail, label: 'Email Accounts' },
      { path: '/dns-health', icon: Shield, label: 'DNS Health' },
      { path: '/inbox-placement', icon: ShieldCheck, label: 'Inbox Placement' },
      { path: '/templates', icon: FileText, label: 'Templates' },
    ],
  },
  {
    title: 'Insights',
    items: [
      { path: '/reports', icon: BarChart3, label: 'Reports' },
      { path: '/calendar', icon: CalendarDays, label: 'Calendar' },
    ],
  },
  {
    title: 'System',
    items: [
      { path: '/settings', icon: Settings, label: 'Settings' },
      { path: '/settings/knowledge-base', icon: BookOpen, label: 'Knowledge Base' },
      { path: '/settings/agent', icon: Sparkles, label: 'Reply Agent' },
      { path: '/settings/ai-usage', icon: BarChart3, label: 'AI Usage', adminOnly: true },
      { path: '/api-docs', icon: Book, label: 'API Docs' },
    ],
  },
]

function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth()
  const initial = (user?.name || user?.email || 'U').charAt(0).toUpperCase()
  const isAdmin = ['Owner', 'Admin'].includes(user?.workspace_role)

  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <div className="brand-mark">
            <img src="/short-logo.png" alt="SynxReach" />
          </div>
          <img src="/logo_black.png" alt="Synxreach" className="brand-logo" />
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">
            <X size={16} />
          </button>
        </div>

        <div className="sidebar-workspace">
          <div className="ws-dot" />
          <div className="ws-meta">
            <span className="ws-label">workspace</span>
            <span className="ws-name">{user?.name || 'Personal'}</span>
          </div>
          <ChevronsRight size={14} className="ws-chev" />
        </div>

        <nav className="sidebar-nav">
          {navGroups.map((group) => (
            <div className="nav-group" key={group.title}>
              <div className="nav-group-title">{group.title}</div>
              <ul className="nav-list">
                {group.items.filter((item) => !item.adminOnly || isAdmin).map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      end={item.path === '/settings'}
                      className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                      onClick={onClose}
                    >
                      <item.icon size={20} className="nav-icon" strokeWidth={1.9} />
                      <span className="nav-label">{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-row">
            <div className="user-avatar">{initial}</div>
            <div className="user-meta">
              <span className="user-name">{user?.name || 'User'}</span>
              <span className="user-email">{user?.email || ''}</span>
            </div>
            <button className="user-logout" onClick={logout} title="Sign out">
              <LogOut size={14} strokeWidth={1.75} />
            </button>
          </div>
        </div>
      </aside>
    </>
  )
}

export default Sidebar
